import '../social_content_context_view.js.coffee'
Monitoring.Views ||= {}

class Monitoring.Views.FacebookContentContextView extends Monitoring.Views.SocialContentContextView

  newSearch: =>
    contextClasses = []
    contextClasses.push Monitoring.Views.FacebookContentParentPostView
    contextClasses.push Monitoring.Views.FacebookContentPreviousCommentsView if @rootParentId != @socialContent.numeric_id()
    contextClasses.push Monitoring.Views.FacebookContentFollowingCommentsView

    contextClasses.splice(1, 0, Monitoring.Views.FacebookContentParentCommentView) if @immediateParentId && @immediateParentId != ''
    _.each(contextClasses, (contextClass) =>
      new contextClass({el: @$el, socialContent: @socialContent}).fetch()
    )
    @show()
